import _ from 'lodash';
import api from '../../api';

const defaultQuery = {
	deleted: 'no',
	unread: 'yes',
	order_by: 'created_at',
	dir: 'desc',
}


const state = {
	query: defaultQuery,
	pagination: null,

	// B
	fetching: false,
	fetched: false,
	// R
	// instance_loading: false,
	// instance_loaded: false,
	// E-A
	instance_saving: false,
	instance_saved: false,
	// D
	instance_deleting: false,
	instance_deleted: false,
};


const actions = {

	setQuery: function(context, params) 
	{
		context.commit('handleSetQuery', params);
	},

	setQueryParam: function(context, payload) 
	{
		context.commit('handleSetQueryParam', payload);
	},

	resetQuery: function(context, params) 
	{
		context.commit('handleSetQuery', defaultQuery);
	},

	fetch: function (context) 
	{
		const query = context.state.query;
		const promise = api.notification.my(query);
		context.commit('handleStatus', { fetching: true });
		promise
			.then((response) => {
				context.commit('handlePaginationResults', response.data);
				context.commit('handleStatus', { fetched: true });
			})
			.catch((error) => {
				context.commit('handleStatus', { fetched: false	});
			})
			.then(() => {
				context.commit('handleStatus', { fetching: false });
			}); 
	},

	read: function (context, payload) 
	{
		const uuid = payload;
		const promise = api.notification.read(uuid);
		context.commit('handleStatus', { instance_saving: uuid });
		promise
			.then((response) => {
				context.commit('handleStatus', { instance_saved: true });
				context.commit('handleRead', uuid);
			})
			.catch((error) => {
				context.commit('handleStatus', { instance_saved: false	});
			})
			.then(() => {
				context.commit('handleStatus', { instance_saving: false });
			}); 
	},

	unread: function (context, payload) 
	{
		const uuid = payload;
		const promise = api.notification.unread(uuid);
		context.commit('handleStatus', { instance_saving: uuid });
		promise
			.then((response) => {
				context.commit('handleStatus', { instance_saved: true });
				context.commit('handleUnread', uuid);
			})
			.catch((error) => {
				context.commit('handleStatus', { instance_saved: false });
			})
			.then(() => {
				context.commit('handleStatus', { instance_saving: false });
			}); 
	},

	delete: function (context, payload) 
	{
		const uuid = payload;
		const promise = api.notification.delete(uuid);
		context.commit('handleStatus', { instance_deleting: uuid });
		promise
			.then((response) => {
				context.commit('handleStatus', { instance_deleted: true });
				context.commit('handleRead', uuid); // ---
			})
			.catch((error) => {
				context.commit('handleStatus', { instance_deleted: false });
			})
			.then(() => {
				context.commit('handleStatus', { instance_deleting: false });
			}); 
	},

};


const mutations = {

	handleSetQuery: function (state, data) {
		_.set(state, 'query', data);
	},

	handleSetQueryParam: function (state, payload) {
		_.each(payload, (value, key) => {
			if (value != null) {
				_.set(state.query, key, value);
			} else {
				_.unset(state.query, key);
			}
		});
		state.query = Object.assign({}, state.query);
	},


	handleRead: function(state, uuid)
	{
		let index = null;
		let found = _.find(state.pagination.data, (record, i) => { 
			index = i;
			return record.uuid == uuid; 
		});
		if (found && index != null) {
			state.pagination.data.splice(index, 1, found);
			// let update = state.pagination;
			// state.pagination = Object.assign({}, state.pagination);
		}
	},

	handleUnread: function(state, uuid)
	{
		let index = null;
		let found = _.find(state.pagination.data, (record, i) => { 
			index = i;
			return record.uuid == uuid; 
		});
		if (found && index != null) {
			state.pagination.data.splice(index, 1, found);
			// let update = state.pagination;
			// state.pagination = Object.assign({}, state.pagination);
		}
	},

	handlePaginationResults: function (state, data) {
		_.set(state, `pagination`, data);
	},


	handleStatus: function (state, payload) {
		_.each(payload, (value, key) => {
			_.set(state, key, value);
		});
	},

};


const getters = {
	unreadNotifications: (state, getters, rootState, rootGetters) => {
		let unread = _.filter(_.get(state.pagination, 'data', []), e => e.read_at == null);
		return _.size(unread);
	},
}



export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}